import { Breadcrumbs, Link, makeStyles, Typography } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import { useContext } from "react";
import { PaymentCreateContext } from "../pages/payment/payment-addproduct/PaymentCreateContext";
import { getMemberType } from "../utils";
import { isLiteVersion } from "../utils/settings";

const useStyles = makeStyles((theme) => ({
  seperator: {
    color: theme.darkGray,
    fontSize: 16,
    marginLeft: 18,
    marginTop: 30,
  },
  noMarginTop: {
    marginTop: 10,
  },
  noMarginLeft: {
    marginLeft: 0,
  },
  path: {
    color: theme.darkGray,
    fontSize: 16,
  },
  finalPath: {
    color: theme.orange,
    fontSize: 16,
  },
  lower: {
    marginTop: 30,
  },
}));

const SfBreadcrumbs = ({
  path,
  className,
  lower,
  noMarginTop,
  noMarginLeft,
}) => {
  const classes = useStyles();
  const [state] = useContext(PaymentCreateContext);
  const elems = path.split("/");

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator="|"
      className={[
        classes.seperator,
        className,
        lower ? classes.lower : null,
        noMarginTop && classes.noMarginTop,
        noMarginLeft && classes.noMarginLeft,
      ]}
    >
      <Link href="/">
        <HomeIcon />
      </Link>
      {elems.map((elem, i) => {
        if (elem === "&user") {
          if (getMemberType(state) === "guest") {
            elem = "Walk-in";
          } else {
            elem = state.member?.firstname;
          }

          return (
            <Link
              style={{ color: "gray" }}
              href={
                getMemberType(state) === "guest"
                  ? `/#/payment`
                  : `/#/payment/search-member`
              }
              key={i}
            >
              {elem}
            </Link>
          );
        }

        if (elem === "") {
          return "";
        } else if (i === elems.length - 1) {
          //Last index
          return (
            <Typography key={i} className={classes.finalPath}>
              {elem}
            </Typography>
          );
        } else {
          const urlLink = URL_MAPS.find(
            (url) => url.name.toLowerCase() === elem.trim().toLowerCase()
          );
          if (urlLink) {
            return (
              <Link
                key={i}
                style={{ color: "gray" }}
                href={`/#/${urlLink.link}`}
              >
                {elem}
              </Link>
            );
          }

          return (
            <Typography key={i} className={classes.path}>
              {elem}
            </Typography>
          );
        }
      })}
    </Breadcrumbs>
  );
};

const URL_MAPS = [
  { name: "Business Insight", link: "bi" },
  { name: "Customer Insight", link: "ci" },
  { name: "Member", link: "ci/member/search" },
  { name: "Members", link: "ci/member/search" },
  { name: "Potential", link: "ci/potential/search" },
  { name: "Potentials", link: "ci/potential/search" },
  { name: "Payment", link: "payment" },
  { name: "Management", link: "management" },
  { name: "Products", link: "products" },
  { name: "Categories", link: "product-categories" },
  { name: "Sub-categories", link: "product-sub-categories" },
  { name: "Users", link: "merchant-users" },
  { name: "Payment Methods", link: "payment-channels" },
  { name: "Tiers", link: "member-tiers" },
  { name: "Branches", link: "merchant-branches" },
  { name: "Discount and Special Offers", link: "offers" },
  { name: "transactions", link: "transactions" },
  { name: "Walk-in", link: "payment" },
  {
    name: "Add Product",
    link: isLiteVersion() ? "payment/lite" : "payment/addproduct",
  },
];

export default SfBreadcrumbs;
